import { useFetchAllVehicleTypes } from "@/features/search-filter/hooks/FilterFetchers/UseFetchAllVehicleTypes";
import { useCallback, useMemo } from "react";

export const useResolveVehicleTypeName = () => {
  const { items: vehicleTypes } = useFetchAllVehicleTypes();

  const vehicleTypeNamesByCode = useMemo(
    () =>
      new Map(
        vehicleTypes.map((vehicleType) => [vehicleType.code, vehicleType.name])
      ),
    [vehicleTypes]
  );

  return useCallback(
    (code: string) => vehicleTypeNamesByCode.get(code) ?? code,
    [vehicleTypeNamesByCode]
  );
};
